import React from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Form, FormInput, FormItemGroup, FormLabel, FormError, SubmitButton } from './Form';

interface LoginFormData {
  email: string;
  password: string;
}

export const LoginForm: React.FC = () => {
  const { login, isLoading, setErrorMessage, setSuccessMessage, setIsLoading } = useAuth();
  const navigate = useNavigate();
  
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm<LoginFormData>();

  const onSubmit = async (data: LoginFormData) => {
    setIsLoading(true);
    setErrorMessage(null);
    setSuccessMessage(null);
    
    try {
      await login(data.email, data.password);
      reset();
      navigate('/');
    } catch (error) {
      // Error is handled by the auth context
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      <FormItemGroup>
        <FormLabel>E-mail</FormLabel>
        <FormInput
          {...register('email', {
            required: 'Email is required',
            pattern: {
              value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
              message: 'Invalid email address',
            },
          })}
          type="email"
          disabled={isLoading}
          placeholder="Enter your email"
        />
        {errors.email && <FormError>{errors.email.message}</FormError>}
      </FormItemGroup>
      
      <FormItemGroup>
        <FormLabel>Password</FormLabel>
        <FormInput
          {...register('password', {
            required: 'Password is required',
            minLength: {
              value: 6,
              message: 'Password must be at least 6 characters',
            },
          })}
          type="password"
          disabled={isLoading}
          placeholder="Enter your password"
        />
        {errors.password && <FormError>{errors.password.message}</FormError>}
      </FormItemGroup>
      
      <FormItemGroup>
        <SubmitButton type="submit" disabled={isLoading}>
          {isLoading ? 'Logging in...' : 'Log in'}
        </SubmitButton>
      </FormItemGroup>
    </Form>
  );
};
